import classNames from 'classnames';

import styles from './styles.module.sass';

type HorizontalRuleProps = {
  className?: string;
};

const HorizontalRule = ({ className }: HorizontalRuleProps) => (
  <hr className={classNames(styles.horizontalRule, className)} />
);

export default HorizontalRule;
